/**
 * File: header.tsx
 * Description: Global page header displaying the Concello de Vigo logo and name,
 * wrapped in a React Router link that navigates back to the home route.
 */
import {
  useTheme,
  Link,
  Box,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ColorsPalletTheme } from "@/constants/colors_pallet_theme";
import { EMAIL_VIGO_FEU } from '@/constants/constants';
import logoVigo from '@/assets/logo_vigo.png';

/**
 * Renders the site-wide header with the Vigo city logo and title.
 * Clicking the header navigates to the root route ("/").
 *
 * @returns {JSX.Element} A sticky header bar with logo and institution name.
 */
function Header() {
  
  // Main App Theme
  const theme = useTheme();
  const colors = ColorsPalletTheme(theme.palette.mode);

  return (
    <Box
      component="header"
      sx={{
        display: { xs: 'row', sm: 'grid', },
        alignItems: { sm: 'center', },
        padding: { xs: '12px', sm: '12px 24px', },
        backgroundColor: colors.gray[950],
        borderBottom: `1px solid ${colors.gray[800]}`,
        gridTemplateColumns: {sm: '1.5fr 1fr 1fr'},
      }}
    >
      <Link
        component={RouterLink}
        to={"/"}
        sx={{
          textDecoration: 'none', 
          color: 'inherit', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: { xs: 'center', sm: 'normal'},
          gap: { xs: '10px', sm: '30px' }
        }}
        >
          <Box
            component="img"
            src={logoVigo}
            alt="Logo Concello de Vigo"
            sx={{ height: { xs: '40px', sm: '60px' }}}
          />
          <Typography variant="h6">
            Ayuntamiento de Vigo
          </Typography>
      </Link>
      <Typography 
        variant="h6" 
        sx={{
          display: { xs: 'flex', sm:'inline' }, 
          justifyContent: { xs: 'center', sm: 'normal'},
          paddingTop: { xs: 1, sm: 0},
          paddingBotton: { xs: 0.5, sm: 0}
        }}
        >
        FAQ Fondos Europeos
      </Typography>
      <Link
        href={`mailto:${EMAIL_VIGO_FEU}`}
        sx={{ width: 'fit-content', color: colors.blueAccent[500], }}
        >
          <Typography 
            variant="h6"
              sx={{
                display: { xs: 'flex', sm:'inline' }, 
                justifyContent: { xs: 'center', sm: 'normal'},
              }}
            >
            Enviar una Solicitud de Artículo
          </Typography>
      </Link>
    </Box>
  );
}

export default Header;
